import { links } from './urls';

const { baseMeteo, baseMeteoEn, baseMeteoEs } = links;

const EN_LABELS = {
    afternoon: `afternoon`,
    avisos_level_0: `No hazard (0)`,
    avisos_level_1: `Moderate (1-2)`,
    avisos_level_2: `Severe (3-4)`,
    avisos_level_3: `Extreme (5-6)`,
    avisos_title: `Warnings Map`,
    avisos_type_0: `Rain accumulation`,
    avisos_type_1: `Rain intensity in 30'`,
    avisos_type_2: `Snow`,
    avisos_type_3: `Sea State`,
    avisos_type_4: `Daytime heat`,
    avisos_type_5: `Cold `,
    avisos_type_6: `Wind`,
    avisos_type_7: `Severe weather`,
    avisos_type_8: `Night Heat`,
    avisos_type_9: `Rain intensity in 3h`,
    button: `Generate widget`,
    cancelled_request: `Operation cancelled due to disassembled component`,
    config_72h_description: ` The 72-hour local weather forecast widget provides hourly information about the sky condition, temperature, rainfall, humidity, perceived temperature, and wind speed and direction in the chosen city.`,
    config_72h_heading: `72-hour local weather forecast`,
    config_8d_description: ` The 8-day local weather forecast widget shows the maximum and minimum temperature, the probability of rain and the symbol forecast for the chosen city for the next 8 days.`,
    config_8d_heading: `8-day local weather forecast`,
    config_avisos_description: `The Catalan Weather Service issues a Severe Weather Alert when it is forecast that certain specific thresholds will be exceeded for each weather parameter. The Severe Weather Alerts widget shows the current alerts at any given time and indicates the weather parameter to which the alert refers. The user can use the link to obtain further information from the website.`,
    config_avisos_heading: `Severe Weather Alerts`,
    config_description: ` The Catalan Weather Service has widgets, which are small applications that can be embedded in websites to show local and general forecasts, severe weather alerts and the weather radar in Catalonia.
    The widgets adapt their size to the space available and have a configurator for defining the city, variables, style and language. 
To embed this information in your website, simply copy and paste the code lines indicated.`,
    config_description_mobile: `Only available on screens over 950 pixels wide.`,
    config_heading: `Weather Widgets`,
    config_heading_mobile: `Caution`,
    config_pred_general_description: ` The general forecast widget shows the 3-day forecast map for Catalonia with morning and afternoon information. When you move the mouse over a region, the regional forecast is shown with maximum and minimum temperature, the probability of rain and the symbol describing the sky condition. 
    Between 00:00 am and 11:30 am, only the forecast for today and tomorrow is available. The third day is added once the predictors have generated the forecast.`,
    config_pred_general_heading: ` General forecast for Catalonia`,
    config_radar_description: ` The Weather Radar widget shows the latest radar image for locating rainfall at any given time. The user can zoom in and follow a link to the radar web page to see the animation of the images.`,
    config_radar_heading: `Weather Radar`,
    config_title: `meteo.cat widget configurator `,
    config_toggle: `Configure widget`,
    days_of_week_long_0: `Sunday`,
    days_of_week_long_1: `Monday`,
    days_of_week_long_2: `Tuesday`,
    days_of_week_long_3: `Wednesday`,
    days_of_week_long_4: `Thursday`,
    days_of_week_long_5: `Friday`,
    days_of_week_long_6: `Saturday`,
    days_of_week_short_0: `Sun.`,
    days_of_week_short_1: `Mon.`,
    days_of_week_short_2: `Tue.`,
    days_of_week_short_3: `Wed.`,
    days_of_week_short_4: `Thu.`,
    days_of_week_short_5: `Fri.`,
    days_of_week_short_6: `Sat.`,
    error_message: `No data received: `,
    footer_about_gencat: `About gencat`,
    footer_about_meteocat: `About meteocat`,
    footer_accessibility: `Accessibility`,
    footer_contact: `Contact`,
    form_err_color: `Low-luminosity colours are not permitted`,
    form_err_no_city: ` Start writing and select a city from the drop-down menu`,
    form_title_charts: `Charts`,
    form_title_city_town_type: `City, text and language`,
    form_title_data_format: `Variables unit`,
    form_title_main: `Configurator`,
    form_title_simple: `Custom text`,
    form_title_widget_style: `Widget Styles`,
    label_alternative_title: `Custom text`,
    label_celsius: `Celsius`,
    label_city: `City`,
    label_color: `Color (in hex format: #123456)`,
    label_corporate: `Corporate`,
    label_fahrenheit: `Fahrenheit`,
    label_kmh: `km/h`,
    label_knots: `kt`,
    label_language: `Language`,
    label_main_chart: ` `,
    label_monochrome: `Custom color`,
    label_rain_accumulation: `Rain accumulation`,
    label_rain_probability: `Rain probability`,
    label_secondary_chart: ` `,
    label_secondary_chart_checkbox: `Show rainfall chart`,
    label_sky: `Sky condition`,
    label_sky_chart: `Sky condition + Temperature`,
    label_temp_format: `Temperature units`,
    label_temperature: `Maximum and minimum temperature`,
    label_temperature_perceived: `Perceived temperature`,
    label_time_interval: `Time interval`,
    label_type: ` `,
    label_wind_chart: `Wind direction and speed`,
    label_wind_direction: `Wind direction `,
    label_wind_speed_format: `Wind speed units`,
    label_wind_velocity: `Wind speed`,
    Loading: `Loading`,
    mapa_avisos_nav_link: `More information on the website`,
    morning: `morning`,
    municipal48h_cel: `Sky`,
    municipal48h_dir_vent: `Wind dir.`,
    municipal48h_hora: `Time`,
    municipal48h_hum_rel: `RH`,
    municipal48h_prec: `Rain`,
    municipal48h_temp: `Temp.`,
    municipal48h_temp_xaf: `Feels like`,
    municipal48h_vel_vent: `Wind Speed`,
    municipal_72h_title: `72-hour local weather forecast`,
    municipal_8d_title: `8-day local weather forecast`,
    nav_data: `Weather stations`,
    nav_data_url: `${baseMeteoEn}${links.navDataUrlEn}`,
    nav_prediction: `Forecast`,
    nav_prediction_url: `${baseMeteoEn}${links.navPredictionUrlEn}`,
    nav_radar: `Radar`,
    nav_radar_url: `${baseMeteoEn}${links.navPredictionUrlEn}`,
    no_data: `No data`,
    placeholder_alternative_title: `Custom text`,
    placeholder_city: `Enter city`,
    prediccio_rain_prob_1: `0%`,
    prediccio_rain_prob_2: `<10%`,
    prediccio_rain_prob_3: `10%-30%`,
    prediccio_rain_prob_4: `30%-70%`,
    prediccio_rain_prob_5: `>70%`,
    prediccio_title: `General forecast for Catalonia `,
    radar_calamarsa: `Hail`,
    radar_feble: `Weak`,
    radar_forta: `Heavy`,
    radar_legend_title: `Rainfall intensity`,
    radar_moderada: `Moderate`,
    radar_nav_link: `Go to animation on our website`,
    radar_title: `Latest radar image`,
    aramet_title: `Current Weather`,
    aramet_type_0: `Temperature`,
    aramet_type_1: `Precipitation`,
    aramet_type_2: `Relative humidity`,    
    aramet_legend_title_0: `Temperature (ºC)`,
    aramet_legend_title_1: `Precipitation (mm)`,    
    aramet_legend_title_2: `Relative humidity (%)`,
    aramet_map_title: `Current Weather Map`,
    config_aramet_heading: `Current Weather`,
    config_aramet_description: `The Current Weather widget allows users to view the current state of temperatures and precipitation across Catalonia. When moving the mouse over the map, depending on the zoom level, the regional or local forecast is displayed, showing a descriptive symbol of the sky conditions, the current temperature, accumulated rainfall and the wind speed and direction.`,
    titol_vent: `Wind`,
    nom_dir_vent_0: `North`, 
    nom_dir_vent_1: `Northeast`, 
    nom_dir_vent_2: `East`, 
    nom_dir_vent_3: `Southeast`, 
    nom_dir_vent_4: `South`, 
    nom_dir_vent_5: `Southwest`, 
    nom_dir_vent_6: `West`, 
    nom_dir_vent_7: `Northwest`,
    rosa_dels_vents_0: `N`,
    rosa_dels_vents_1: `NNE`, 
    rosa_dels_vents_2: `NE`, 
    rosa_dels_vents_3: `ENE`, 
    rosa_dels_vents_4: `E`, 
    rosa_dels_vents_5: `ESE`, 
    rosa_dels_vents_6: `SE`, 
    rosa_dels_vents_7: `SSE`, 
    rosa_dels_vents_8: `S`, 
    rosa_dels_vents_9: `SSO`, 
    rosa_dels_vents_10: `SO`, 
    rosa_dels_vents_11: `OSO`, 
    rosa_dels_vents_12: `O`, 
    rosa_dels_vents_13: `ONO`, 
    rosa_dels_vents_14: `NO`, 
    rosa_dels_vents_15: `NNO`,
    s_d: `n/d`,
    estat_cel_1: `Clear sky`,
    estat_cel_2: `High clouds`,
    estat_cel_3: `Mostly sunny to partly cloudy`,
    estat_cel_4: `Cloudy`,
    estat_cel_5: `Medium clouds with drizzle`,
    estat_cel_6: `Rain`,
    estat_cel_7: `Heavy rain`,
    estat_cel_8: `Thunderstorm`,
    estat_cel_9: `Thunderstorm with hail`,
    estat_cel_10: `Snow`,
    estat_cel_11: `Fog`,
    estat_cel_12: `Mist`,
    estat_cel_13: `Heavy snowfall`,
    estat_cel_20: `Mostly cloudy to cloudy`,
    estat_cel_21: `Cloudy`,
    estat_cel_22: `Haze`,
    estat_cel_23: `Partly cloudy with showers`,
    estat_cel_24: `Heavy rain with thunderstorm`,
    estat_cel_25: `Heavy rain with thunderstorm and hail`,
    estat_cel_26: `Snow shower`,
    estat_cel_27: `Light snow`,
    estat_cel_28: `Heavy snowfall`,
    estat_cel_29: `Heavy sleet`,
    estat_cel_30: `Sleet`,
    estat_cel_31: `Mostly cloudy with showers`,
    estat_cel_32: `Cloudy with drizzle`,


    today: `Today`,
    tomorrow: `Tomorrow`,
    dAfterTomorrow: `The day after tomorrow`,
    unknown_variable: `You tried to load information from an unknown variable`,

};

const ES_LABELS = {
    afternoon: `tarde`,
    avisos_level_0: `Sin peligro (0)`,
    avisos_level_1: `Peligro moderado (1-2)`,
    avisos_level_2: `Peligro alto (3-4)`,
    avisos_level_3: `Peligro muy alto (5-6)`,
    avisos_title: `Mapa de avisos`,
    avisos_type_0: `Acumulación de lluvia`,
    avisos_type_1: `Intensidad de lluvia en 30'`,
    avisos_type_2: `Nieve`,
    avisos_type_3: `Estado de la mar`,
    avisos_type_4: `Calor`,
    avisos_type_5: `Frío`,
    avisos_type_6: `Viento`,
    avisos_type_7: `Tiempo violento`,
    avisos_type_8: `Calor nocturna`,
    avisos_type_9: `Intensidad de lluvia en 3h`,
    button: `Generar widget`,
    cancelled_request: `Operación cancelada porque se ha desmontado el componente`,
    config_72h_description: `El widget de predicción municipal a 72 horas facilita información horaria del estado del cielo, temperatura, precipitación, humedad, sensación térmica y velocidad y dirección del viento del municipio elegido para el día de hoy, mañana y el día siguiente.`,
    config_72h_heading: `Predicción municipal a 72 horas`,
    config_8d_description: `El widget de predicción municipal a 8 días muestra la temperatura máxima y mínima, la probabilidad de precipitación y el símbolo previsto para el municipio escogido los próximos 8 días.`,
    config_8d_heading: `Predicción municipal a 8 días`,
    config_avisos_description: `El Servei Meteorològic de Catalunya emite un aviso de Situación Meteorológica de Peligro (SMP) cuando se prevé la superación de unos umbrales específicos para cada meteoro. El widget de avisos de situación meteorológica de peligro muestra los avisos vigentes en cada momento e indica el meteoro que supera el umbral. A través del enlace la persona usuari puede complementar la información en la página web.`,
    config_avisos_heading: `Avisos SMP`,
    config_description: `El Servei Meteorològic de Catalunya (SMC) ha desarrollado widgets, pequeñas aplicaciones que pueden ser incrustadas en las páginas web, para mostrar la predicción municipal, general, avisos de situación meteorológica de peligro y el radar meteorológico en Catalunya.
Los widgets adaptan su tamaño al espacio disponible y disponen de un configurador que permite definir el municipio, las variables, el estilo y el idioma.
Para poner esta información en su sitio web se deben copiar las líneas de código indicadas.`,
    config_description_mobile: `Sólo disponible en pantallas de más de 950 píxels de ancho.`,
    config_heading: ` Widgets del tiempo `,
    config_heading_mobile: `Atención`,
    config_pred_general_description: `El widget de predicción general permite consultar el mapa de la predicción para Catalunya a 3 días con información de la mañana y la tarde. Al desplazar el ratón por encima de una comarca se muestra la predicción comarcal donde se indica la temperatura máxima y mínima, la probabilidad de lluvia y el símbolo descriptivo del estado del cielo.
    Entre las 00:00 horas y las 11:30 horas sólo está disponible la información para el mismo día y el día siguiente, una vez los predictores han elaborado la predicción se incorpora el tercer día.`,
    config_pred_general_heading: `Predicción general de Catalunya`,
    config_radar_description: `El widget de radar meteorológico muestra la última imagen de radar para localizar la precipitación en cada momento. La persona usuaria puede hacer zoom y dispone de un enlace en la página web para poder ver la animación de la última hora.`,
    config_radar_heading: `Radar meteorológico`,
    config_title: `Configurador de los widgets de meteo.cat`,
    config_toggle: `Configurar widget`,
    days_of_week_long_0: `Domingo`,
    days_of_week_long_1: `Lunes`,
    days_of_week_long_2: `Martes`,
    days_of_week_long_3: `Miércoles`,
    days_of_week_long_4: `Jueves`,
    days_of_week_long_5: `Viernes`,
    days_of_week_long_6: `Sábado`,
    days_of_week_short_0: `do.`,
    days_of_week_short_1: `lu.`,
    days_of_week_short_2: `ma.`,
    days_of_week_short_3: `mi.`,
    days_of_week_short_4: `ju.`,
    days_of_week_short_5: `vi.`,
    days_of_week_short_6: `sa.`,
    error_message: `No se han podido obtener los datos: `,
    footer_about_gencat: `Sobre gencat`,
    footer_about_meteocat: `Sobre meteocat`,
    footer_accessibility: `Accesibilidad`,
    footer_contact: `Contacto`,
    footer_legal: `Aviso legal`,
    form_err_color: `Los colores con baja luminosidad no están permitidos`,
    form_err_no_city: `Empieza a escribir y selecciona un municipio del desplegable`,
    form_title_charts: `Gráficas`,
    form_title_city_town_type: `Municipio, texto e idioma`,
    form_title_data_format: `Unidad de las variables`,
    form_title_main: `Configurador:`,
    form_title_simple: `Idioma y estilos del widget`,
    form_title_widget_style: `Estilos del widget`,
    label_alternative_title: `Texto personalizado`,
    label_celsius: `Celsius`,
    label_city: `Municipio`,
    label_color: `Color (en formato hex: #123456)`,
    label_corporate: `Corporativo`,
    label_fahrenheit: `Fahrenheit`,
    label_kmh: `km/h`,
    label_knots: `kt`,
    label_language: `Idioma`,
    label_main_chart: ` `,
    label_monochrome: `Color personalizado`,
    label_rain_accumulation: `Precipitación acumulada`,
    label_rain_probability: `Probabilidad de precipitación`,
    label_secondary_chart: ` `,
    label_secondary_chart_checkbox: `Visualizar gráfica de precipitación`,
    label_sky: `Estado del cielo`,
    label_sky_chart: `Estado del cielo + temperatura `,
    label_temp_format: `Unidad de temperatura`,
    label_temperature: `Temperatura mínima y máxima`,
    label_temperature_perceived: `Sensación térmica`,
    label_time_interval: `Intervalo horario`,
    label_type: ` `,
    label_wind_chart: `Dirección y velocidad del viento`,
    label_wind_direction: `Dirección del viento`,
    label_wind_speed_format: `Unidad de velocidad del viento`,
    label_wind_velocity: `Velocidad del viento`,
    Loading: `Cargando`,
    morning: `mañana`,
    mapa_avisos_nav_link: `Más información detallada en la web`,
    municipal48h_cel: `Cielo`,
    municipal48h_dir_vent: `Dir. del viento`,
    municipal48h_hora: `Hora`,
    municipal48h_hum_rel: `HR`,
    municipal48h_prec: `Prec.`,
    municipal48h_temp: `Temp.`,
    municipal48h_temp_xaf: `Sens. térmica`,
    municipal48h_vel_vent: `Vel. viento`,
    municipal_72h_title: `Predicción municipal a 72 horas`,
    municipal_8d_title: `Predicción municipal a 8 días`,
    nav_data: `Datos estaciones`,
    nav_data_url: `${baseMeteoEs}${links.navDataUrlEs}`,
    nav_prediction: `Predicción`,
    nav_prediction_url: `${baseMeteoEs}${links.navPredictionUrlEs}`,
    nav_radar: `Radar`,
    nav_radar_url: `${baseMeteoEs}${links.navRadarUrlEs}`,
    no_data: `No data`,
    placeholder_alternative_title: `Texto personalizado`,
    placeholder_city: `Escribe un municipio`,
    prediccio_rain_prob_1: `0%`,
    prediccio_rain_prob_2: `<10%`,
    prediccio_rain_prob_3: `10%-30%`,
    prediccio_rain_prob_4: `30%-70%`,
    prediccio_rain_prob_5: `>70%`,
    prediccio_title: `Predicción general de Catalunya`,
    radar_calamarsa: `Granizo`,
    radar_feble: `Débil`,
    radar_forta: `Fuerte`,
    radar_legend_title: `Intensidad de precipitación`,
    radar_moderada: `Moderada`,
    radar_nav_link: `Ver la animación en la web`,
    radar_title: `Última imagen de radar`,
    aramet_title: `Tiempo Actual`,
    aramet_type_0: `Temperatura`,
    aramet_type_1: `Precipitación`,   
    aramet_type_2: `Humedad relativa`,  
    aramet_legend_title_0: `Temperatura (ºC)`,
    aramet_legend_title_1: `Precipitación (mm)`,    
    aramet_legend_title_2: `Humedad relativa (%)`,
    aramet_map_title: `Mapa del Tiempo Actual`,
    config_aramet_heading: `Tiempo Actual`,
    config_aramet_description: `El widget del Tiempo Actual permite consultar el mapa del estado actual de las temperaturas y precipitaciones para Cataluña. Cuando se desplaza el ratón por encima de una comarca o municipio, en función del nivel de zoom, se muestra la predicción comarcal o municipal donde se indica el símbolo descriptivo del estado del cielo, la temperatura actual, la lluvia acumulada y la velocidad y dirección del viento.`,
    titol_vent: `Viento`,
    nom_dir_vent_0: `Norte`, 
    nom_dir_vent_1: `Nordeste`, 
    nom_dir_vent_2: `Este`, 
    nom_dir_vent_3: `Sudeste`, 
    nom_dir_vent_4: `Sur`, 
    nom_dir_vent_5: `Sudoeste`, 
    nom_dir_vent_6: `Oeste`, 
    nom_dir_vent_7: `Noroeste`,
    rosa_dels_vents_0: `N`,
    rosa_dels_vents_1: `NNE`, 
    rosa_dels_vents_2: `NE`, 
    rosa_dels_vents_3: `ENE`, 
    rosa_dels_vents_4: `E`, 
    rosa_dels_vents_5: `ESE`, 
    rosa_dels_vents_6: `SE`, 
    rosa_dels_vents_7: `SSE`, 
    rosa_dels_vents_8: `S`, 
    rosa_dels_vents_9: `SSO`, 
    rosa_dels_vents_10: `SO`, 
    rosa_dels_vents_11: `OSO`, 
    rosa_dels_vents_12: `O`, 
    rosa_dels_vents_13: `ONO`, 
    rosa_dels_vents_14: `NO`, 
    rosa_dels_vents_15: `NNO`,
    s_d: `s/d`,

    estat_cel_1: `Cielo despejado`,
    estat_cel_2: `Nubes altas`,
    estat_cel_3: `Entre poco y parcialmente nuboso`,
    estat_cel_4: `Muy nuboso`,
    estat_cel_5: `Nubes medias con llovizna`,
    estat_cel_6: `Lluvia`,
    estat_cel_7: `Chubasco`,
    estat_cel_8: `Tormenta`,
    estat_cel_9: `Tormenta con granizo`,
    estat_cel_10: `Niebla`,
    estat_cel_11: `Bruma`,
    estat_cel_12: `Boirina`,
    estat_cel_13: `Chubasco de nieve`,
    estat_cel_20: `Parcialmente nuboso o muy nuboso`,
    estat_cel_21: `Nuboso`,
    estat_cel_22: `Calima`,
    estat_cel_23: `Parcialmente nuboso con chubascos`,
    estat_cel_24: `Chubasco con tormenta`,
    estat_cel_25: `Chubasco con tormenta y granizo`,
    estat_cel_26: `Nevada intermitente`,
    estat_cel_27: `Nevadas débiles`,
    estat_cel_28: `Chubasco de nieve`,
    estat_cel_29: `Chubasco de aguanieve`,
    estat_cel_30: `Aguanieve`,
    estat_cel_31: `Muy nuboso con chubascos`,
    estat_cel_32: `Nuboso con llovizna`,


    today: `Hoy`,
    tomorrow: `Mañana`,
    dAfterTomorrow: `Pasado mañana`,
    unknown_variable: `Se ha intentado cargar información de una variable desconocida`,
};

const CA_LABELS = {
    afternoon: `tarda`,
    avisos_level_0: `Sense perill (0)`,
    avisos_level_1: `Perill moderat (1-2)`,
    avisos_level_2: `Perill alt (3-4)`,
    avisos_level_3: `Perill molt alt (5-6)`,
    avisos_title: `Mapa d'avisos`,
    avisos_type_0: `Acumulació de pluja`,
    avisos_type_1: `Intensitat de pluja en 30'`,
    avisos_type_2: `Neu`,
    avisos_type_3: `Estat de la mar`,
    avisos_type_4: `Calor`,
    avisos_type_5: `Fred`,
    avisos_type_6: `Vent`,
    avisos_type_7: `Temps violent`,
    avisos_type_8: `Calor nocturna`,
    avisos_type_9: `Intensitat de pluja en 3h`,
    button: `Generar Giny`,
    cancelled_request: `Operació cancel·lada perquè s'ha desmuntat el component`,
    config_72h_description: ` El giny de predicció municipal a 72 hores facilita informació horària de l'estat del cel, temperatura, precipitació, humitat, temperatura de xafogor i velocitat i direcció del vent del municipi escollit pel dia d'avui, demà i demà passat.`,
    config_72h_heading: ` Predicció municipal a 72 hores`,
    config_8d_description: ` El giny de predicció municipal a 8 dies mostra la temperatura màxima i mínima, la probabilitat de precipitació i el símbol previst pel municipi escollit dels pròxims 8 dies.`,
    config_8d_heading: ` Predicció municipal a 8 dies`,
    config_avisos_description: ` El Servei Meteorològic de Catalunya emet un avís de Situació Meteorològica de Perill (SMP) quan es preveu la superació d'uns llindars específics per cada meteor. El giny d'avisos de situació meteorològica de perill mostra els avisos vigents en cada moment i indica el meteor del qual s'avisa. A través de l'enllaç la persona usuària pot complementar la informació a la pàgina web.`,
    config_avisos_heading: `Avisos SMP`,
    config_description: ` El Servei Meteorològic de Catalunya (SMC) ha desenvolupat ginys, petites aplicacions que poden ser incrustades a les pàgines web, per mostrar la predicció municipal, general, avisos de situació meteorològica de perill i el radar meteorològic a Catalunya.
    Els ginys adapten la seva mida a l'espai disponible i disposen d'eines de configuració que permeten definir el municipi, les variables, l'estil i l'idioma. 
    Per posar aquesta informació al vostre lloc web només heu de copiar les línies de codi indicades.`,
    config_description_mobile: ` Només disponible en pantalles de més de 950 píxels d'amplada.`,
    config_heading: `Ginys del Temps`,
    config_heading_mobile: `Atenció`,
    config_pred_general_description: ` El giny de predicció general permet consultar el mapa de la predicció per Catalunya a 3 dies amb informació del matí i la tarda. En desplaçar el ratolí per sobre una comarca es mostra la predicció comarcal on s'indica la temperatura màxima i mínima, la probabilitat de pluja i el símbol descriptiu de l'estat del cel. 
    Entre les 00:00 hores i les 11:30 hores només està disponible la informació pel dia present i l'endemà, un cop els predictors han elaborat la predicció s'incorpora el tercer dia.`,
    config_pred_general_heading: ` Predicció general de Catalunya`,
    config_radar_description: ` El giny de radar meteorològic mostra la última imatge de radar per tal de localitzar la precipitació en cada moment. La persona usuària pot fer zoom i disposa d'un enllaç a la pàgina web de radar per poder veure l'animació de la darrera hora.`,
    config_radar_heading: ` Radar meteorològic`,
    config_title: ` Eines de configuració dels ginys de meteo.cat`,
    config_toggle: `Configurar Giny`,
    days_of_week_long_0: `Diumenge`,
    days_of_week_long_1: `Dilluns`,
    days_of_week_long_2: `Dimarts`,
    days_of_week_long_3: `Dimecres`,
    days_of_week_long_4: `Dijous`,
    days_of_week_long_5: `Divendres`,
    days_of_week_long_6: `Dissabte`,
    days_of_week_short_0: `dg.`,
    days_of_week_short_1: `dl.`,
    days_of_week_short_2: `dm.`,
    days_of_week_short_3: `dc.`,
    days_of_week_short_4: `dj.`,
    days_of_week_short_5: `dv.`,
    days_of_week_short_6: `ds.`,
    error_message: `No s'han pogut obtenir les dades: `,
    footer_about_gencat: `Sobre gencat`,
    footer_about_meteocat: `Sobre meteocat`,
    footer_accessibility: `Accessibilitat`,
    footer_contact: `Contacte`,
    footer_legal: `Avís legal`,
    form_err_color: `Els colors amb baixa lluminositat no estan permesos`,
    form_err_no_city: ` Comença a escriure i selecciona un municipi del desplegable `,
    form_title_charts: `Gràfiques`,
    form_title_city_town_type: ` Municipi, text i idioma`,
    form_title_data_format: ` Unitat de les variables`,
    form_title_main: `Configurador:`,
    form_title_simple: `Idioma i estils del giny`,
    form_title_widget_style: `Estils del giny`,
    label_alternative_title: ` Text personalitzat`,
    label_celsius: `Celsius`,
    label_city: `Municipi`,
    label_color: `Color (en format hex: #123456)`,
    label_corporate: `Corporatiu`,
    label_fahrenheit: `Fahrenheit`,
    label_kmh: `km/h`,
    label_knots: `Kt`,
    label_language: `Idioma`,
    label_main_chart: ` `,
    label_monochrome: `Color personalitzat`,
    label_rain_accumulation: `Precipitació acumulada`,
    label_rain_probability: `Probabilitat de precipitació`,
    label_secondary_chart: ` `,
    label_secondary_chart_checkbox: `Mostrar gràfica de precipitació`,
    label_sky: `Estat de cel`,
    label_sky_chart: `Estat de cel + Temperatura`,
    label_temp_format: `Unitat de temperatura`,
    label_temperature: `Temperatura mínima i màxima`,
    label_temperature_perceived: `Temperatura percebuda (xafogor)`,
    label_time_interval: `Interval horari`,
    label_type: ` `,
    label_wind_chart: `Direcció i velocitat del vent`,
    label_wind_direction: `Direcció del vent`,
    label_wind_speed_format: `Unitat de velocitat del vent`,
    label_wind_velocity: `Velocitat del vent`,
    Loading: `Carregant`,
    morning: `matí`,
    mapa_avisos_nav_link: `Més informació detallada al web`,
    municipal48h_cel: `Cel`,
    municipal48h_dir_vent: `Dir. Vent`,
    municipal48h_hora: `Hora`,
    municipal48h_hum_rel: `HR`,
    municipal48h_prec: `Prec.`,
    municipal48h_temp: `Temp`,
    municipal48h_temp_xaf: `Temp. Xaf`,
    municipal48h_vel_vent: `Vel. Vent`,
    municipal_72h_title: `Predicció municipal a 72 hores`,
    municipal_8d_title: `Predicció municipal a 8 dies`,
    nav_data: `Dades estacions`,
    nav_data_url: `${baseMeteo}${links.navDataUrlCa}`,
    nav_prediction: `Predicció`,
    nav_prediction_url: `${baseMeteo}${links.navPredictionUrlCa}`,
    nav_radar: `Radar`,
    nav_radar_url: `${baseMeteo}${links.navRadarUrlCa}`,
    no_data: `No data`,
    placeholder_alternative_title: `Text personalitzat`,
    placeholder_city: `Escriu un municipi`,
    prediccio_rain_prob_1: `0%`,
    prediccio_rain_prob_2: `<10%`,
    prediccio_rain_prob_3: `10%-30%`,
    prediccio_rain_prob_4: `30%-70%`,
    prediccio_rain_prob_5: `>70%`,
    prediccio_title: `Predicció general de Catalunya`,
    radar_calamarsa: `Calamarsa`,
    radar_feble: `Feble`,
    radar_forta: `Forta`,
    radar_legend_title: `Intensitat de Precipitació`,
    radar_moderada: `Moderada`,
    radar_nav_link: `Veure l'animació al web`,
    radar_title: `Última imatge de radar`,
    aramet_title: `Temps Actual`,
    aramet_type_0: `Temperatures`,
    aramet_type_1: `Precipitacions`,    
    aramet_type_2: `Humitat`, 
    aramet_legend_title_0: `Temperatura (ºC)`,
    aramet_legend_title_1: `Precipitació (mm)`,
    aramet_legend_title_2: `Humitat relativa (%)`,
    aramet_map_title: `Mapa del Temps Actual`,
    config_aramet_heading: `Temps Actual`,
    config_aramet_description: `El giny de temps actual permet consultar el mapa de l'estat actual de les temperatures i precipitacions per Catalunya. En desplaçar el ratolí per sobre una comarca o municipi, en funció del nivell de zoom, es mostra la predicció comarcal o municipal on s'indica el símbol descriptiu de l'estat del cel, la temperatura actual, la pluja acumulada i velocitat i direcció del vent.`,
    titol_vent: `Vent`,
    nom_dir_vent_0: `Tramuntana`, 
    nom_dir_vent_1: `Gregal`, 
    nom_dir_vent_2: `Llevant`, 
    nom_dir_vent_3: `Xaloc`, 
    nom_dir_vent_4: `Migjorn`, 
    nom_dir_vent_5: `Garbí`, 
    nom_dir_vent_6: `Ponent`, 
    nom_dir_vent_7: `Mestral`,
    rosa_dels_vents_0: `N`,
    rosa_dels_vents_1: `NNE`, 
    rosa_dels_vents_2: `NE`, 
    rosa_dels_vents_3: `ENE`, 
    rosa_dels_vents_4: `E`, 
    rosa_dels_vents_5: `ESE`, 
    rosa_dels_vents_6: `SE`, 
    rosa_dels_vents_7: `SSE`, 
    rosa_dels_vents_8: `S`, 
    rosa_dels_vents_9: `SSO`, 
    rosa_dels_vents_10: `SO`, 
    rosa_dels_vents_11: `OSO`, 
    rosa_dels_vents_12: `O`, 
    rosa_dels_vents_13: `ONO`, 
    rosa_dels_vents_14: `NO`, 
    rosa_dels_vents_15: `NNO`,
    s_d: `s/d`,
    estat_cel_1: `Cel serè`,
    estat_cel_2: `Núvols alts`,
    estat_cel_3: `Entre poc i mig ennuvolat`,
    estat_cel_4: `Molt ennuvolat`,
    estat_cel_5: `Núvols mitjans amb plugims`,
    estat_cel_6: `Pluja`,
    estat_cel_7: `Xàfec`,
    estat_cel_8: `Tempesta`,
    estat_cel_9: `Tempesta amb calamarsa`,
    estat_cel_10: `Nevada`,
    estat_cel_11: `Boira`,
    estat_cel_12: `Boirina`,
    estat_cel_13: `Xàfec de neu`,
    estat_cel_20: `Entre mig i molt ennuvolat`,
    estat_cel_21: `Ennuvolat`,
    estat_cel_22: `Calitja`,
    estat_cel_23: `Mig ennuvolat amb ruixats`,
    estat_cel_24: `Xàfec amb tempesta`,
    estat_cel_25: `Xàfec amb tempesta i calamarsa`,
    estat_cel_26: `Ruixat de neu`,
    estat_cel_27: `Neu feble`,
    estat_cel_28: `Xàfec de neu`,
    estat_cel_29: `Xàfec d'aiguaneu`,
    estat_cel_30: `Aiguaneu`,
    estat_cel_31: `Molt ennuvolat amb ruixats`,
    estat_cel_32: `Ennuvolat amb plugims`,

    today: `Avui`,
    tomorrow: `Demà`,
    dAfterTomorrow: `Demà passat`,
    unknown_variable: `S'ha intentat carregar informació d'una variable desconeguda`,
};

export const translate = (langCode, key) => {
    switch (langCode) {
        case 'en':
            return EN_LABELS[key] ? EN_LABELS[key] : key;
        case 'es':
            return ES_LABELS[key] ? ES_LABELS[key] : key;
        default:
            return CA_LABELS[key] ? CA_LABELS[key] : key;
    }
};



// WEBPACK FOOTER //
// ./src/utils/translations.js